<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentTime /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentTime from '@/components/team/dashboard/modules/report/time/ContentTime.vue'

export default 
{
  name: 'Time',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentTime
  }
}
</script>

<style>
</style>